import { render, staticRenderFns } from "./TabNavbar.vue?vue&type=template&id=380f840c&"
import script from "./TabNavbar.vue?vue&type=script&lang=js&"
export * from "./TabNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports